import React from 'react'
import random from '../../assets/random_pp.png'
import Footer from '../../components/Footer/Footer'
import { Link } from 'react-router-dom'
import styles from './Account.module.css'

const Account = () => {
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header>
                <h1>Account</h1>
                <div className={styles.profile}>
                    <img src={random} alt="random-pic" />
                    <div className={styles.textContainer}>
                        <h2>John Doe</h2>
                        <Link to="/my-profile">
                            <small>View profile</small>
                        </Link>
                    </div>
                </div>
            </header>

            <main>
                <div className={styles.row}>
                    <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                    <div className={styles.rowText}>
                        <h2>Saved Addresses</h2>
                        <p>Save address for quick process</p>
                    </div>
                </div>
                <div className={styles.row}>
                    <i className={styles.icon + " fas fa-envelope"}></i>
                    <div className={styles.rowText}>
                        <h2>Contact us</h2>
                        <p>Connect us for any query {"&"} issue</p>
                    </div>
                </div>
                <div className={styles.row}>
                    <i className={styles.icon + " fas fa-file-alt"}></i>
                    <div className={styles.rowText}>
                        <h2>Terms {"&"} Conditions</h2>
                        <p>Know our Terms {"&"} Conditions</p>
                    </div>
                </div>
                <div className={styles.row}>
                    <i className={styles.icon + " fas fa-user-astronaut"}></i>
                    <div className={styles.rowText}>
                        <h2>Do you like this App?</h2>
                        <p>Contact Developer</p>
                    </div>
                </div>
                <div className={styles.row}>
                    <i className={styles.icon + " fas fa-vector-square"}></i>
                    <div className={styles.rowText}>
                        <h2>Share App</h2>
                        <p>Share with friends and family</p>
                    </div>
                </div>
                <div className={styles.row}>
                    <i className={styles.icon + " fas fa-sign-out-alt"}></i>
                    <div className={styles.rowText}>
                        <Link to="/login"><h2>Logout</h2></Link>
                        <p>Signout from current account</p>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    )
}

export default Account
